import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import cookie from 'react-cookies';
import { STICKY_BANNER_COOKIE } from 'components/NavBar';
import { serialize } from '../../../utils';
import { constants } from 'os';

export default function withNewsletter(WrappedComponent) {
  return class NewsletterHOC extends Component {
    static propTypes = { children: PropTypes.node };

    static defaultProps = { children: null };

    constructor() {
      super();

      this.refForm = createRef();

      this.state = {
        subscribed: false,
      };
    }

    setSubscribe = () => {
      const url = window.location.href;
      const joinChar = url.indexOf('?') > -1 ? '&' : '?';

      window.location.href = `${url + joinChar}subscribed=true`;
    }

    handleSubmit = e => {
      e.preventDefault();

      const userId = '?visitor_id=' + cookie.load('visitor_id688533');
      const formUrl = 'https://go.boldare.com/l/688533/2019-02-05/91s';
      const url = formUrl.concat(userId);
      const form = this.refForm.current;

      fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        },
        body: serialize(form),
      })
        .then(() => {
          if (
            typeof window !== 'undefined' &&
            window.fbq &&
            typeof window.fbq === 'function'
          ) {
            window.fbq('track', 'Sign up');
          }
          cookie.save(STICKY_BANNER_COOKIE, true, { path: '/' });
          window.location.pathname === '/newsletter/' ? this.setSubscribe() : this.setState({ subscribed: true });
        })
        .catch(error => console.log(error));
    };

    render() {
      const { subscribed } = this.state;

      return (
        <WrappedComponent
          {...this.props}
          subscribed={subscribed}
          refForm={this.refForm}
          handleSubmit={this.handleSubmit}
        />
      );
    }
  };
}
